export default __webpack_public_path__ + "media/music/4111ed8696b567ca71324a7cb65ce5d9.mp3";